/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/light");

var $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
.setOptions({
  java_package: "com.jc.icp.frames"
})
.addJSON({
  RealtimeLocationFrame: {
    fields: {
      terminalNum: {
        type: "string",
        id: 2
      },
      model: {
        type: "string",
        id: 3
      },
      protocol: {
        type: "string",
        id: 4
      },
      gpsDatetime: {
        type: "google.protobuf.Timestamp",
        id: 5
      },
      recvDatetime: {
        type: "google.protobuf.Timestamp",
        id: 6
      },
      longitude: {
        type: "double",
        id: 7
      },
      latitude: {
        type: "double",
        id: 8
      },
      altitude: {
        type: "double",
        id: 9
      },
      speed: {
        type: "uint32",
        id: 10
      },
      direction: {
        type: "uint32",
        id: 11
      },
      mileage: {
        type: "uint32",
        id: 12
      },
      state: {
        type: "string",
        id: 13
      },
      alarm: {
        type: "string",
        id: 14
      },
      expand: {
        type: "string",
        id: 15
      }
    }
  },
  google: {
    nested: {
      protobuf: {
        nested: {
          Timestamp: {
            fields: {
              seconds: {
                type: "int64",
                id: 1
              },
              nanos: {
                type: "int32",
                id: 2
              }
            }
          }
        }
      }
    }
  },
  ReqLinkCheckFrame: {
    fields: {
      opDatetime: {
        type: "google.protobuf.Timestamp",
        id: 1
      }
    }
  },
  RspLinkCheckFrame: {
    fields: {
      opDatetime: {
        type: "google.protobuf.Timestamp",
        id: 1
      }
    }
  },
  ShortMessageDataFrame: {
    fields: {
      simNum: {
        type: "string",
        id: 1
      },
      smsContent: {
        type: "string",
        id: 2
      },
      direction: {
        type: "uint32",
        id: 3
      },
      opDatetime: {
        type: "google.protobuf.Timestamp",
        id: 4
      }
    }
  },
  SubscribeDeviceLocationFrame: {
    fields: {
      selectAll: {
        type: "bool",
        id: 1
      },
      terminalNums: {
        rule: "repeated",
        type: "string",
        id: 2
      }
    }
  },
  SubscribeSmsFrame: {
    fields: {
      selectAll: {
        type: "bool",
        id: 1
      },
      simNums: {
        rule: "repeated",
        type: "string",
        id: 2
      }
    }
  },
  UnsubscribeDeviceLocationFrame: {
    fields: {
      selectAll: {
        type: "bool",
        id: 1
      },
      terminalNums: {
        rule: "repeated",
        type: "string",
        id: 2
      }
    }
  },
  UnsubscribeSmsFrame: {
    fields: {
      selectAll: {
        type: "bool",
        id: 1
      },
      simNums: {
        rule: "repeated",
        type: "string",
        id: 2
      }
    }
  }
});

module.exports = $root;
